/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionStatus } from './SessionStatus';
import {
    SessionStatusFromJSON,
    SessionStatusFromJSONTyped,
    SessionStatusToJSON,
    SessionStatusToJSONTyped,
} from './SessionStatus';
import type { ActivityManifest } from './ActivityManifest';
import {
    ActivityManifestFromJSON,
    ActivityManifestFromJSONTyped,
    ActivityManifestToJSON,
    ActivityManifestToJSONTyped,
} from './ActivityManifest';

/**
 * The only session shape ever exposed without authentication.
 * @export
 * @interface PublicLearnSession
 */
export interface PublicLearnSession {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    status: SessionStatus;
    /**
     * 
     */
    manifest: ActivityManifest;
}



/**
 * Check if a given object implements the PublicLearnSession interface.
 */
export function instanceOfPublicLearnSession(value: object): value is PublicLearnSession {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('manifest' in value) || value['manifest'] === undefined) return false;
    return true;
}

export function PublicLearnSessionFromJSON(json: any): PublicLearnSession {
    return PublicLearnSessionFromJSONTyped(json, false);
}

export function PublicLearnSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicLearnSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': SessionStatusFromJSON(json['status']),
        'manifest': ActivityManifestFromJSON(json['manifest']),
    };
}

export function PublicLearnSessionToJSON(json: any): PublicLearnSession {
    return PublicLearnSessionToJSONTyped(json, false);
}

export function PublicLearnSessionToJSONTyped(value?: PublicLearnSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': SessionStatusToJSON(value['status']),
        'manifest': ActivityManifestToJSON(value['manifest']),
    };
}

